import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import _get from 'lodash/get';
import { useSelector } from 'react-redux';

import Drawer, { DrawerHeader } from 'common/components/drawer';
import { DrawerState } from 'common/entities/drawer/DrawerTypes';
import { MatricesState } from 'common/entities/crew/MatricesTypes';
import { useActions } from 'utils/hooks';

import Body from './body';
import { selectListOptionsFromStore } from 'store/lists/selectors';
import * as listActions from 'store/lists/actions';

import { constructConfig } from './body/helpers';

const MatricesDrawer = ({ drawer, active, refetchData, isOcean = false }) => {
  const [config, setConfig] = useState();
  const isEditMode = _get(active, 'id');
  const isFromOcean = _get(active, 'is_from_ocean');
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);
  const matrixRuleTypes = useSelector(state =>
    selectListOptionsFromStore(state, 'crew-matrix-rule-types')
  );
  const isEditDisabled = !isOcean && isFromOcean;

  useEffect(() => {
    fetchListOptions('crew-matrix-rule-types');
  }, [fetchListOptions]);

  useEffect(() => {
    if (matrixRuleTypes?.length) {
      const constructedConfig = constructConfig(matrixRuleTypes);
      setConfig(constructedConfig);
    }
  }, [matrixRuleTypes]);

  return (
    <Drawer {...drawer} size="lg">
      <DrawerHeader>{isEditMode ? 'Edit' : 'Create new'} Crew Matrix</DrawerHeader>

      {config ? (
        <Body
          config={config}
          drawer={drawer}
          active={active}
          matrixRuleTypes={matrixRuleTypes}
          refetchData={refetchData}
          isOcean={isOcean}
          isEditDisabled={isEditDisabled}
        />
      ) : null}
    </Drawer>
  );
};

export default MatricesDrawer;

MatricesDrawer.propTypes = {
  drawer: DrawerState.isRequired,
  refetchData: PropTypes.func.isRequired,
  active: MatricesState,
  isOcean: PropTypes.bool
};
